var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUser(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", null, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_148564",
    "data-name": "Rectangle 148564",
    width: 30,
    height: 30,
    transform: "translate(1136 55)",
    fill: "#0c0c0b"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "friends",
    transform: "translate(-1136 -55)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "avatar",
    transform: "translate(1139.954 57.014)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11695",
    "data-name": "Group 11695",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8814",
    "data-name": "Path 8814",
    d: "M142.6,13.995h.172a4.963,4.963,0,0,0,3.792-1.64c2.071-2.334,1.726-6.336,1.689-6.718-.134-2.867-1.49-4.238-2.609-4.878A5.98,5.98,0,0,0,142.752,0h-.091a5.989,5.989,0,0,0-2.894.737c-1.129.64-2.506,2.012-2.641,4.9-.038.382-.382,4.383,1.689,6.718A4.943,4.943,0,0,0,142.6,13.995Zm-4.039-8.224c0-.016.005-.032.005-.043.177-3.856,2.915-4.271,4.088-4.271h.065c1.452.032,3.921.624,4.088,4.271a.105.105,0,0,0,.005.043c.005.038.382,3.7-1.328,5.621a3.525,3.525,0,0,1-2.77,1.151h-.054a3.514,3.514,0,0,1-2.765-1.151C138.191,9.477,138.556,5.8,138.562,5.771Z",
    transform: "translate(-131.649)",
    fill: "#0c0c0b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8815",
    "data-name": "Path 8815",
    d: "M58.164,265.933v-.016c0-.043-.005-.086-.005-.134-.032-1.065-.1-3.555-2.436-4.351l-.054-.016a15.519,15.519,0,0,1-4.464-2.033.726.726,0,0,0-.834,1.189,16.75,16.75,0,0,0,4.911,2.243c1.253.446,1.393,1.786,1.431,3.012a1.08,1.08,0,0,0,.005.134,9.764,9.764,0,0,1-.113,1.662,19.8,19.8,0,0,1-9.482,2.205,19.908,19.908,0,0,1-9.488-2.211,9.242,9.242,0,0,1-.113-1.662c0-.043.005-.086.005-.134.038-1.226.177-2.566,1.431-3.012a16.909,16.909,0,0,0,4.911-2.243.726.726,0,0,0-.834-1.189,15.348,15.348,0,0,1-4.464,2.033c-.022.005-.038.011-.054.016-2.334.8-2.4,3.292-2.436,4.351a1.081,1.081,0,0,1-.005.134v.016a8.248,8.248,0,0,0,.274,2.436.69.69,0,0,0,.28.339,20.343,20.343,0,0,0,10.5,2.571,20.405,20.405,0,0,0,10.5-2.571.72.72,0,0,0,.28-.339A8.654,8.654,0,0,0,58.164,265.933Z",
    transform: "translate(-36.073 -245.301)",
    fill: "#0c0c0b"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUser);
export default __webpack_public_path__ + "static/media/user.17257b8d.svg";
export { ForwardRef as ReactComponent };